import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogService } from 'projects/lossreporting-library/src/lib/services/log.service';
import { LossReportService } from 'projects/lossreporting-library/src/lib/services/loss-report.service';
import { RoutingService } from 'projects/lossreporting-library/src/lib/services/routing.service';
import { SfAnalyticsService } from 'projects/lossreporting-library/src/lib/services/sf-analytics.service';
import { BaseComponent } from 'projects/lossreporting-library/src/lib/shared/base/base.component';
import { CliffLogCodes } from 'projects/lossreporting-library/src/lib/shared/constants/cliff-log-constants';

@Component({
  selector: 'olr-incident-water-damage',
  templateUrl: './incident-water-damage.component.html',
  styleUrls: ['./incident-water-damage.component.css', '../../../../shared/styles/question-common-styling.scss']
})
export class IncidentWaterDamageComponent extends BaseComponent implements OnInit {

  constructor(
    private analytics: SfAnalyticsService,
    public lossReportService: LossReportService,
    public routingService: RoutingService,
    public router: Router,
    public logService: LogService
    ) {
      super(lossReportService, router, routingService, logService);
     }

  ngOnInit(): void {
    this.analytics.sendData('incident-type-water');
    this.highlightButtonStandardAnswer();
  }

  answerQuestion(answer: string): void {
    const logDetails = this.logService.getLogDetails();
    logDetails.incidentType = answer;
    this.logService.log(CliffLogCodes.WATER_DAMAGE_CAUSE, logDetails);

    // intercepting heavyRainStorm and groundWater answers to navigate to flood-policy component. Routing to next page done there.
    // if flood-policy component is removed, remove this if block and change back to just updateAnswer(answer).
    if (answer === 'heavyRainStorm' || answer === 'groundWater') {
      this.updateAnswerWithoutRouting(answer);
      this.router.navigate(['/homeandproperty/incident-details/flood-policy']);
    } else {
      this.updateAnswer(answer);
    }
  }
}
